"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = __importDefault(require("@meeva/smart-admin-bundle/js/meeva/app"));
const jquery_1 = __importDefault(require("jquery"));
class LoginForm {
    init() {
        if (window.location.pathname === '/login') {
            setInterval(async () => {
                jquery_1.default.ajax('/ping', {
                    method: 'GET',
                })
                    .then((response) => {
                    if (response.success) {
                        location.reload();
                    }
                })
                    .catch(() => {
                    //Ignore Errors
                });
            }, 5 * 60 * 1000);
            const showPasswordIcon = (0, jquery_1.default)('#showPasswordIcon');
            const hidePasswordIcon = (0, jquery_1.default)('#hidePasswordIcon');
            const passwordInput = (0, jquery_1.default)('#password');
            showPasswordIcon.on('click', () => {
                passwordInput.prop('type', 'text');
                showPasswordIcon.hide();
                hidePasswordIcon.show();
            });
            hidePasswordIcon.on('click', () => {
                passwordInput.prop('type', 'password');
                hidePasswordIcon.hide();
                showPasswordIcon.show();
            });
        }
        if (window.location.pathname === '/2fa') {
            (0, jquery_1.default)('#twofactor-providers').on('change', function () {
                window.location.href = (0, jquery_1.default)('option:selected', this).val();
            });
        }
    }
}
exports.default = LoginForm;
app_1.default.loadAndRegister('HumanResourceLoginForm', LoginForm);
